import React from "react";
import { onKeyDown } from "helpers/dom-events";

function handleSkipNav() {
	const mainContent = document.getElementById("pass-main");
	mainContent?.focus();
}

const SkipNavLinks = () =>  (
	<button
		onClick={handleSkipNav}
		onKeyDown={onKeyDown(handleSkipNav)}
		aria-label="skip to main content"
		className="transition left-0 bg-primary absolute p-3 m-3 -translate-y-16 focus:translate-y-0 z-[100] text-white">
		Skip Navigation
	</button>
);

export default SkipNavLinks;